import { twMerge } from "tailwind-merge";

/**
 * `pl-2.5 -ml-2.5` is the room a focused input's 2px ring needs: this box clips, and `overflow-x`
 * cannot stay visible while `overflow-y` is hidden. The negative margin hands the indent back, so
 * page content stays where it was. `contentPadding` in `components/partials/layout` absorbs the
 * overshoot and repeats the same 10px one level up — both levels are required.
 */
export const FillHeightPage = ({ className, ...rest }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge(
        "flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden pl-2.5 -ml-2.5 pt-3 gap-4",
        className,
      )}
      {...rest}
    />
  );
};
